/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
/*
jQuery Infinite Pages v0.2.0
https://github.com/magoosh/jquery-infinite-pages

Released under the MIT License
*/

//
// Built with a class-based template for jQuery plugins in Coffeescript:
// https://gist.github.com/rjz/3610858
//

export default function($, window) {
  // Define the plugin class
  class InfinitePages {
    static initClass() {

      // Default settings
      this.prototype.defaults = {
        debug: false,  // set to true to log messages to the console
        navSelector: 'a[rel=next]',
        buffer: 1000,  // 1000px buffer by default
        loading: null, // optional callback when next-page request begins
        success: null, // optional callback when next-page request finishes
        error:   null, // optional callback when next-page request fails
        context: window, // context to define the scrolling container
        state: {
          paused:  false,
          loading: false
        }
      };
    }

    // Constructs the new InfinitePages object
    //
    // container - the element containing the infinite table and pagination links
    constructor(container, options) {
      this.options = $.extend({}, this.defaults, options);
      this.$container = $(container);
      this.$table = $(container).find('table');
      this.$context = $(this.options.context);
      this.init();
    }

    // Setup and bind to related events
    init() {

      // Debounce scroll event to improve performance
      let scrollTimeout = null;
      const scrollHandler = (() => this.check());

      return this.$context.scroll(function() {
        if (scrollTimeout) {
          clearTimeout(scrollTimeout);
          scrollTimeout = null;
        }
        return scrollTimeout = setTimeout(scrollHandler, 250);
      });
    }

    // Internal helper for logging messages
    _log(msg) {
      if (this.options.debug) { return (typeof console !== 'undefined' && console !== null ? console.log(msg) : undefined); }
    }

    // Check the distance of the nav selector from the bottom of the window and fire
    // load event if close enough
    check() {
      const nav = this.$container.find(this.options.navSelector);
      if (nav.length === 0) {
        return this._log("No more pages to load");
      } else {
        const windowBottom = this.$context.scrollTop() + this.$context.height();
        const distance = nav.offset().top - windowBottom;

        if (this.options.state.paused) {
          return this._log("Paused");
        } else if (this.options.state.loading) {
          return this._log("Waiting...");
        } else if (distance > this.options.buffer) {
          return this._log(`${distance - this.options.buffer}px remaining...`);
        } else {
          return this.next(); // load the next page
        }
      }
    }

    // Load the next page
    next() {
      if (this.options.state.done) {
        return this._log("Loaded all pages");
      } else {
        this._loading();

        return $.getScript(this.$container.find(this.options.navSelector).attr('href'))
          .done(() => this._success())
          .fail(() => this._error());
      }
    }

    _loading() {
      this.options.state.loading = true;
      this._log("Loading next page...");
      if (typeof this.options.loading === 'function') {
        return this.$container.find(this.options.navSelector).each(this.options.loading);
      }
    }

    _success() {
      this.options.state.loading = false;
      this._log("New page loaded!");
      if (typeof this.options.success === 'function') {
        return this.$container.find(this.options.navSelector).each(this.options.success);
      }
    }

    _error() {
      this.options.state.loading = false;
      this._log("Error loading new page :(");
      if (typeof this.options.error === 'function') {
        return this.$container.find(this.options.navSelector).each(this.options.error);
      }
    }

    // Pause firing of events on scroll
    pause() {
      this.options.state.paused = true;
      return this._log("Scroll checks paused");
    }

    // Resume firing of events on scroll
    resume() {
      this.options.state.paused = false;
      this._log("Scroll checks resumed");
      return this.check();
    }
  }
  InfinitePages.initClass();

  // Define the plugin
  return $.fn.extend({infinitePages(option, ...args) {
    return this.each(function() {
      const $this = $(this);
      let data = $this.data('infinitepages');

      if (!data) {
        $this.data('infinitepages', (data = new InfinitePages(this, option)));
      }
      if (typeof option === 'string') {
        return data[option].apply(data, args);
      }});
  }});

}
